import {
  PropsWithChildren,
  useEffect,
  useMemo,
  useSyncExternalStore,
} from "react";
import { createEngineWorkerClient } from "../client/createEngineWorkerClient";
import { EngineWorkerContext } from "./EngineWorkerContext";

export function EngineWorkerProvider({ children }: PropsWithChildren) {
  const client = useMemo(
    () =>
      createEngineWorkerClient(
        () =>
          new Worker(new URL("../engineWorker.ts", import.meta.url), {
            type: "module",
          }),
      ),
    [],
  );
  const state = useSyncExternalStore(client.subscribe, client.getState);

  useEffect(() => {
    client.start();
    return () => client.stop();
  }, [client]);

  const context = useMemo(
    () => ({
      error: state.status === "failed" ? state.error : null,
      loading: state.status === "loading",
      request: client.request,
      waitUntilReady: client.waitUntilReady,
    }),
    [client, state],
  );

  return (
    <EngineWorkerContext.Provider value={context}>
      {children}
    </EngineWorkerContext.Provider>
  );
}
